import { useState } from 'react';
import { reviews, stats } from '@/mocks/reviews';

export default function ReviewSection() {
  const [current, setCurrent] = useState(0);
  const total = reviews.length;

  const prev = () => setCurrent((c) => (c - 1 + total) % total);
  const next = () => setCurrent((c) => (c + 1) % total);

  const review = reviews[current];

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="mx-auto max-w-7xl">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              <span className="text-foreground-400">「</span>
              读者口碑
              <span className="text-foreground-400">」</span>
            </h2>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-14">
            {stats.map((stat) => (
              <div key={stat.label} className="text-center p-4">
                <div className="font-heading text-2xl md:text-3xl font-bold text-primary-500">
                  {stat.value}
                </div>
                <div className="text-foreground-500 text-sm mt-1">{stat.label}</div>
              </div>
            ))}
          </div>

          <div className="max-w-3xl mx-auto">
            <div className="bg-background-50 rounded-2xl p-6 md:p-10 relative">
              <div className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-foreground-950 text-background-50 text-sm font-medium mb-6">
                <i className="ri-star-fill text-primary-400 text-xs"></i>
                <span>{review.rating}.0</span>
              </div>

              <blockquote className="font-heading text-lg md:text-xl text-foreground-800 leading-relaxed mb-8">
                &ldquo;{review.content}&rdquo;
              </blockquote>

              <div className="flex items-center gap-4">
                <img
                  src={review.avatar}
                  alt={review.name}
                  className="w-12 h-12 rounded-full object-cover"
                  loading="lazy"
                />
                <div>
                  <div className="font-medium text-foreground-950 text-sm">{review.name}</div>
                  <div className="text-foreground-500 text-xs">{review.identity}</div>
                </div>
              </div>

              <div className="absolute bottom-6 right-6 md:bottom-10 md:right-10 flex items-center gap-2">
                <button
                  onClick={prev}
                  className="w-10 h-10 flex items-center justify-center rounded-lg border border-background-300 hover:border-foreground-400 bg-background-50 text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer"
                  aria-label="上一条"
                  type="button"
                >
                  <i className="ri-arrow-left-line"></i>
                </button>
                <button
                  onClick={next}
                  className="w-10 h-10 flex items-center justify-center rounded-lg bg-foreground-950 hover:bg-foreground-800 text-background-50 transition-colors cursor-pointer"
                  aria-label="下一条"
                  type="button"
                >
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </div>

            <div className="flex items-center justify-center gap-2 mt-6">
              {reviews.map((_, idx) => (
                <button
                  key={idx}
                  onClick={() => setCurrent(idx)}
                  className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                    idx === current ? 'w-6 bg-primary-500' : 'bg-background-300'
                  }`}
                  aria-label={`第${idx + 1}条评价`}
                  type="button"
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}